// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popup-container-one {
  position: fixed;  /* Keep popup fixed on the screen */
  top: 50%;         /* Center vertically */
  left: 50%;        /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust to exact center */
  background: black; /* Semi-transparent background */
  padding: 20px;
  width: 400px; /* Set fixed width */
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  margin-right: 880px;
  margin-bottom: 500px;
  margin-left: 280px;
  z-index: 1000; /* Ensure it stays on top */
  border: 2px solid white;
  height: 300px;
}

.popup-container-two {
  position: fixed;  /* Keep popup fixed on the screen */
  top: 50%;         /* Center vertically */
  left: 50%;        /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust to exact center */
  background: rgba(234, 229, 234, 0.75); /* Semi-transparent background */
  padding: 20px;
  width: 300px; /* Set fixed width */
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  margin-right: 880px;
  margin-top: 180px;
  margin-left: 300px;
  z-index: 1000; /* Ensure it stays on top */
}

.popup-container-three {
  position: fixed;  /* Keep popup fixed on the screen */
  top: 50%;         /* Center vertically */
  left: 50%;        /* Center horizontally */
  transform: translate(-50%, -50%); /* Adjust to exact center */
  background: rgba(234, 229, 234, 0.75); /* Semi-transparent background */
  padding: 20px;
  width: 300px; /* Set fixed width */
  border-radius: 8px;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);
  margin-right: 680px;
  margin-bottom: 200px;
  z-index: 1000; /* Ensure it stays on top */
}

.popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent dark background */
  display: flex;
  justify-content: center;
  align-items: center;
  
  z-index: 999; /* Behind the popup but above everything else */
}`, "",{"version":3,"sources":["webpack://./src/components/common/ForgotPassword/ForgotPassword.css"],"names":[],"mappings":"AAAA;EACE,eAAe,GAAG,mCAAmC;EACrD,QAAQ,UAAU,sBAAsB;EACxC,SAAS,SAAS,wBAAwB;EAC1C,gCAAgC,EAAE,2BAA2B;EAC7D,iBAAiB,EAAE,gCAAgC;EACnD,aAAa;EACb,YAAY,EAAE,oBAAoB;EAClC,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,kBAAkB;EAClB,aAAa,EAAE,2BAA2B;EAC1C,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,eAAe,GAAG,mCAAmC;EACrD,QAAQ,UAAU,sBAAsB;EACxC,SAAS,SAAS,wBAAwB;EAC1C,gCAAgC,EAAE,2BAA2B;EAC7D,qCAAqC,EAAE,gCAAgC;EACvE,aAAa;EACb,YAAY,EAAE,oBAAoB;EAClC,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,eAAe,GAAG,mCAAmC;EACrD,QAAQ,UAAU,sBAAsB;EACxC,SAAS,SAAS,wBAAwB;EAC1C,gCAAgC,EAAE,2BAA2B;EAC7D,qCAAqC,EAAE,gCAAgC;EACvE,aAAa;EACb,YAAY,EAAE,oBAAoB;EAClC,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,oBAAoB;EACpB,aAAa,EAAE,2BAA2B;AAC5C;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B,EAAE,qCAAqC;EACrE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;;EAEnB,YAAY,EAAE,+CAA+C;AAC/D","sourcesContent":[".popup-container-one {\n  position: fixed;  /* Keep popup fixed on the screen */\n  top: 50%;         /* Center vertically */\n  left: 50%;        /* Center horizontally */\n  transform: translate(-50%, -50%); /* Adjust to exact center */\n  background: black; /* Semi-transparent background */\n  padding: 20px;\n  width: 400px; /* Set fixed width */\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n  margin-right: 880px;\n  margin-bottom: 500px;\n  margin-left: 280px;\n  z-index: 1000; /* Ensure it stays on top */\n  border: 2px solid white;\n  height: 300px;\n}\n\n.popup-container-two {\n  position: fixed;  /* Keep popup fixed on the screen */\n  top: 50%;         /* Center vertically */\n  left: 50%;        /* Center horizontally */\n  transform: translate(-50%, -50%); /* Adjust to exact center */\n  background: rgba(234, 229, 234, 0.75); /* Semi-transparent background */\n  padding: 20px;\n  width: 300px; /* Set fixed width */\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n  margin-right: 880px;\n  margin-top: 180px;\n  margin-left: 300px;\n  z-index: 1000; /* Ensure it stays on top */\n}\n\n.popup-container-three {\n  position: fixed;  /* Keep popup fixed on the screen */\n  top: 50%;         /* Center vertically */\n  left: 50%;        /* Center horizontally */\n  transform: translate(-50%, -50%); /* Adjust to exact center */\n  background: rgba(234, 229, 234, 0.75); /* Semi-transparent background */\n  padding: 20px;\n  width: 300px; /* Set fixed width */\n  border-radius: 8px;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.3);\n  margin-right: 680px;\n  margin-bottom: 200px;\n  z-index: 1000; /* Ensure it stays on top */\n}\n\n.popup-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.5); /* Semi-transparent dark background */\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  \n  z-index: 999; /* Behind the popup but above everything else */\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
